import React from 'react'
import {Link} from 'react-router-dom'
import StaysEmptyState from '../../assets/stays-empty-state.png'

const NotFoundPage = () => {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center gap-8">
      <img src={StaysEmptyState} className="h-52 my-8 mx-auto" />

      <div className="text-center">
        <h2 className="text-4xl font-light">Oops, page not found!</h2>
      </div>
      <Link to="/" className="link">
        go back
      </Link>
    </div>
  )
}

export default NotFoundPage
